<template>
  <div>
    <div class="header header-fixed header-logo-center">
      <router-link to="/home" class="header-title color-theme">TBD Admin User Mngt</router-link>
      <router-link to="/admin/users/new" class="header-icon color-theme header-icon-4">
        <i class="fas fa-plus-circle"></i>
      </router-link>
      <p class="header-icon header-icon-1">
        <i @click="goBack()" class="fas fa-arrow-left"></i>
      </p>
    </div>
    <div class="page-content header-clear-small">
      <div class="card card-style">
        <div class="content">
          <h3>User Lists</h3>
          <p>To get more contact information simply tap the "Edit" button</p>
          <div class="user-slider">
            <div v-for="user in users.data" :key="user.id" class="user-left">
              <div class="d-flex">
                <div><img src="/images/pictures/faces/default.png" class="mr-3 rounded-circle shadow-l" width="50"></div>
                <div>
                  <h5 class="mt-1 mb-0">{{ user.name }}</h5>
                  <p class="font-10 mt-n1 color-red2-dark">{{ user.phone_number }} / {{user.email}}</p>
<!--                  <p class="font-10 mt-n1 color-red2-dark">{{ user.phone_number }} / {{user.email}}</p>-->
                </div>
                <div class="ml-auto"><span class="next-slide-user badge bg-red2-dark mt-2 p-2 font-8">Edit</span></div>
              </div>
            </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PageAppBar from "@/components/PageAppBar";
import global from "@/mixins/global";
import axios from "axios";
export default {
  mounted() {
    axios.get(this.base_url+"users", this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{
      this.users = response.data
    }).catch(error=>{this.error = error})
  },
  data(){
    return {
      users: []
    }
  },
  mixins: [global],
  name: "UserManagement",
    components: {}
  }
</script>

<style scoped>

</style>